// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerText_root__3Kyrc"};